import { getCurrentInstance, computed, reactive } from 'vue';
import { ModuleInvoiceFormNumber } from '@/stores/moduleConst';
import { useStore } from 'vuex';

// Combo grid Tài khoản nợ, có
export const useCacheInvoiceFormNumberComboConfig = () => {
  const { proxy } = getCurrentInstance();

  const store = useStore();

  const invoiceFormNumberData = computed(() => {
    const invoiceFormNumbers = store.getters[`${ModuleInvoiceFormNumber}/items`];
    return invoiceFormNumbers.filter(x => !x.inactive && !x.is_parent);
  });

  // config columns combo
  const cacheInvoiceFormNumberComboConfig = reactive({
    data: invoiceFormNumberData,
    columns: [
      {
        title: 'Mẫu số',
        dataField: 'invoice_form_number_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên mẫu số',
        dataField: 'invoice_form_number_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'invoice_form_number_code',
    valueField: 'invoice_form_number_id',
    queryMode: 'local',
    dropdownWidth: 600,
  });

  return { cacheInvoiceFormNumberComboConfig };
};
